export default "__VITE_ASSET__a711fade__"